export default {
    strict: true,
    fields: {
        name: {
            type: "string",
        },
        mdmId: {
            type: "string",
        },
    },
};
